module.exports = __webpack_public_path__ + "static/img/login.1554e15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/login.jpg
// module id = 1408
// module chunks = 0